import { Component, Input } from '@angular/core';

@Component({
  selector: 'loading-game',
  template: `<div class="box loading-game" [ngStyle]="{ 'font-size': this.size + 'px' }"></div>`,
  styleUrls: ['./loading-game.scss'],
})
export class LoadingGame {
  @Input() public size: number = 50;
}
